import {
  type BoostTAEConfig,
  getBoostTAE,
  type IBoostTAE,
} from '@boost/widget-integration-tae/lib';
import { Injectable } from 'framework/di';

import type { PlatformRouter } from '../platform.interface';

@Injectable
export class ShopifyRouter implements PlatformRouter {
  get TAE(): IBoostTAE {
    return getBoostTAE();
  }

  get TAEConfig(): BoostTAEConfig {
    return this.TAE.config;
  }

  get page() {
    const page = this.TAEConfig?.generalSettings?.page;
    if (page === 'index') return 'home';
    if (page === 'cart') return 'cart';
    if (page === 'collection') {
      const collectionTags = this.TAEConfig?.generalSettings?.collection_tags;
      if (Array.isArray(collectionTags) && collectionTags.length > 0) {
        return 'tag';
      }
      return 'collection';
    }
    if (page === 'product') return 'product';
    if (page === 'search') return 'search';
    if (window.location.pathname.indexOf('/collections/vendors') > -1) return 'vendor';
    if (window.location.pathname.indexOf('/collections/types') > -1) return 'types';
    if (window.location.pathname.indexOf('/pages/') > -1) return 'page';
  }

  get routes() {
    return window.Shopify.routes;
  }
}
